import { Button } from '@awazevr/design-system.components.button'
import styled from 'styled-components'

export const ButtonLinkStyled = styled(Button)`
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
  font-size: inherit;
`
